
.Scheduler-variables {
    --Scheduler-spacing-xs: 2px;
    --Scheduler-spacing-sm: 4px;
    --Scheduler-spacing-md: .5rem;
}

.Scheduler {
    composes: Scheduler-variables;
    position: relative;
    overflow: hidden;
    container-type: inline-size;
    height: 100%;
}
